import { Skeleton, Stack } from "@mui/material";
import { FilmTileLoading } from "./FilmTileLoading.tsx";
import React from "react";

export const FilmListingLoading: React.FC = () => {
  return (
    <Stack spacing={{ xs: 2, md: 5 }} sx={{ width: "100%" }}>
      <Skeleton height={130} />
      <FilmTileLoading></FilmTileLoading>
      <FilmTileLoading></FilmTileLoading>
    </Stack>
  );
};
